import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/users/managers/create")({
  component: () => (
    <MaskRedirect
      to="/admin/users/managers"
      action="create"
      mask="/admin/users/managers/create"
    />
  ),
});
